import { withInstall } from '@xzx-design/utils'
import _Switch from './src/switch'

export const Switch = withInstall(_Switch)
export default Switch

export * from './src/switch'
export * from './src/types'
